export default "__VITE_ASSET__6b5575ab__"